import { render, staticRenderFns } from "./Notifications2.vue?vue&type=template&id=12bb61c0&"
import script from "./Notifications2.vue?vue&type=script&lang=js&"
export * from "./Notifications2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports